// Unpublished Work © 2025 Deere & Company.

import {useSelector} from 'react-redux';
import {isFeatureToggled} from '../feature-toggles';

const isFeatureToggledAndOutOfBusiness = (isFeatureToggledEnableForOutOfBusiness, isLegalNameVerified, isDeceasedOrOutOfBusiness) =>
    isFeatureToggledEnableForOutOfBusiness && !isLegalNameVerified && isDeceasedOrOutOfBusiness;

export const isJdfNameDetailsReadOnly = (isFeatureToggledEnableForOutOfBusiness, isLegalNameVerified, isDeceasedOrOutOfBusiness) =>
    isLegalNameVerified || isFeatureToggledAndOutOfBusiness(isFeatureToggledEnableForOutOfBusiness, isLegalNameVerified, isDeceasedOrOutOfBusiness);

export const useJDFNameDetailsReadOnly = () => {
    const isFeatureToggledEnableForOutOfBusiness = isFeatureToggled('JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB');
    const isLegalNameVerified = useSelector((state) => state.addCustomer.customer.legalNameVerInd);
    const isDeceasedOrOutOfBusiness = useSelector((state) => state.addCustomer.customer.deceasedOrOutOfBusiness);

    return isJdfNameDetailsReadOnly(isFeatureToggledEnableForOutOfBusiness, isLegalNameVerified, isDeceasedOrOutOfBusiness);
};

export const isFeatureToggleEnableForJDFMobilePhone = () => isFeatureToggled('JDF_MOBILE_PHONE_NUMBER_REQUIRED');
